import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import JP1 from './components/JP1';
import JP2 from './components/JP2';
import JP3 from './components/JP3';
import JP4 from './components/JP4';
import NA1 from './components/NA1';
import NA2 from './components/NA2';
// import E1 from './components/E1';
// import F from './components/F';
import { useGlobal } from '@/utils/useGlobal';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import O from './components/O';
import P from './components/P';
import Q from './components/Q';
import R from './components/R';
import S from './components/S';
import SectionA1 from './components/SectionA1';
import SectionA2 from './components/SectionA2';
import SectionA3 from './components/SectionA3';
import SectionA4 from './components/SectionA4';
import SectionA5 from './components/SectionA5';
import SectionA6 from './components/SectionA6';
import SectionCarousel from './components/SectionCarousel';
import T from './components/T';
import U from './components/U';
import V from './components/V';
import W from './components/W';
import X from './components/X';

export default function IndexDynamic({ freeQuote, freeQuoteBack }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const SITE_JP = 'jp';
    const NA_SITES: string[] = ['us', 'ca', 'br', 'mx'];
    const EU_SITES: string[] = ['eu', 'uk', 'de', 'fr', 'it', 'es'];
    return (
        <>
            {NA_SITES.includes(locale) && <NA2 />}
            <B />
            <C />
            {NA_SITES.includes(locale) && <NA1 />}
            <D />
            {locale !== SITE_JP && <E />}
            {locale === SITE_JP && <JP1 />}
            {locale === SITE_JP && <P freeQuote={freeQuote} freeQuoteBack={freeQuoteBack} />}
            {locale === SITE_JP && <JP2 />}
            {locale === SITE_JP && <JP3 />}
            {locale === SITE_JP && <JP4 />}
            {locale === SITE_JP && <L />}
            <G />
            <H />
            <I />
            <J />
            {locale !== SITE_JP && <K />}
            {locale !== SITE_JP && <L />}
            <M />
            {locale !== SITE_JP && <N />}
            {locale !== SITE_JP && <O />}
            {locale !== SITE_JP && <P />}
            <Q />
            <div className="gray-box">
                {locale !== SITE_JP && <R />}
                <S />
                <T />
                {['us'].includes(locale) && <U />}
                <V />
                {!['br', 'mx'].includes(locale) && <W />}
            </div>
            <X />
            <SectionA6 />
            <SectionCarousel />
            <SectionA1 />
            <SectionA2 />
            <SectionA3 />
            <SectionA4 />
            <SectionA5 />
        </>
    );
}
